import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import classnames from 'classnames';
import './styles/main';

import ManageSearchPinsModal from './manage_search_pins/manage_modal';

const PinnedSearches = (props) => {
  const [showModal, updateShowModal] = useState(false);
  const {
    editable,
    pinsDropdownSetting,
    searchFilters,
    searchQuery,
    submitSearchQuery,
    updateSearchFilters,
  } = props;

  const renderPinnedSearchesButtons = () => {
    const featuredSearchFilters = searchFilters.filter((filter) => filter.featured);
    return featuredSearchFilters.map((filter) => {
      const active = searchQuery === filter.query;
      const staticClasses = 'search-pill nav-pills-custom c-custom-color c-custom-pin-background';

      return (
        <button
          key={filter.key}
          className={classnames(staticClasses, { 'pill-active': active })}
          data-term={filter.query}
          data-key={filter.key}
          onClick={() => submitSearchQuery(filter.query, null, { searchKey: filter.key })}
          type="button"
        >
          <span className="bff-pin" aria-hidden="true" />
          {filter.label}
        </button>
      );
    });
  };

  const handleOnChange = (e) => {
    let newQuery = '';

    if (e) {
      if (e.value === 'no-pin-selected') {
        newQuery = '';
      } else {
        newQuery = e.value;
      }
    }

    submitSearchQuery(newQuery);
  };

  const renderPinnedSearchesDropdownList = () => {
    const clearOption = { value: 'no-pin-selected', label: '-' };
    let selectedPin = clearOption;

    const featuredSearchFilters = searchFilters.filter((filter) => (filter.featured));
    const options = featuredSearchFilters.map((filter) => {
      const active = searchQuery === filter.query;
      const option = { value: filter.query, label: filter.label };

      if (active) {
        selectedPin = option;
      }

      return option;
    });

    options.unshift(clearOption);

    return (
      <div className="select-list-wrapper">
        <Select
          className="select-list"
          clearable={false}
          value={selectedPin}
          onChange={handleOnChange}
          options={options}
        />
      </div>
    );
  };

  const displaySettingClass = pinsDropdownSetting
    ? 'display-pins-dropdown'
    : 'display-pins-buttons';

  return (
    <ul
      id="pinned-searches-list"
      className={`j-filter-bar j-searches-list ${displaySettingClass}`}
    >
      {editable && (
        <li className="edit search-pill t-manage-pinned-searches">
          <button
            className="button tertiary pins-button"
            onClick={() => updateShowModal(true)}
            type="button"
          >
            <span className="bff-edit" />
            {t('Pins')}
          </button>
        </li>
      )}
      {(editable && showModal) && (
        <ManageSearchPinsModal
          resetShowModal={() => updateShowModal(false)}
          searchFilters={searchFilters}
          updateSearchFilters={updateSearchFilters}
        />
      )}
      {searchFilters.length && pinsDropdownSetting
        ? renderPinnedSearchesDropdownList()
        : renderPinnedSearchesButtons()
      }
    </ul>
  );
};


PinnedSearches.propTypes = {
  editable: PropTypes.bool.isRequired,
  searchFilters: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
  })),
  searchQuery: PropTypes.string,
  pinsDropdownSetting: PropTypes.bool,
  submitSearchQuery: PropTypes.func.isRequired,
  updateSearchFilters: PropTypes.func.isRequired,
};

PinnedSearches.defaultProps = {
  pinsDropdownSetting: null,
  searchFilters: [],
  searchQuery: null
};

export default PinnedSearches;
